<template>
    <b-modal ref="tiket-modal" v-model="show" hide-footer no-close-on-backdrop>
        <template #modal-header="{}">
            <h5>Pendaftaran Berhasil!</h5>
            <b-button class="close" @click="onClose()">x</b-button>
        </template>
        <h6>Silahkan Catat atau Screen Capture untuk Nomor Pendaftaran Anda.</h6>
        <table id="tiket-table" class="paleBlueRows">
            <tbody>
                <tr>
                    <td>Kode Booking</td>
                </tr>
                <tr>
                    <td>{{ datum.kdBooking }}</td>
                </tr>
                <tr>
                    <td>No. RM/Nama Pasien</td>
                </tr>
                <tr>
                    <td>
                        <small>{{ datum.rm }}</small> / {{ datum.nama }}
                    </td>
                </tr>
                <tr>
                    <td>No. Antrian Loket</td>
                </tr>
                <tr>
                    <td>{{ datum.noAntrianPendaftaran }}</td>
                </tr>
                <tr>
                    <td>Poli yang Dituju</td>
                </tr>
                <tr>
                    <td>
                        {{ datum.poliTujuan }}
                        <br />
                        {{ datum.dokterTujuan }}
                    </td>
                </tr>
                <tr>
                    <td>No. Urut Poli</td>
                </tr>
                <tr>
                    <td>{{ datum.noAntrianPoli }}</td>
                </tr>
                <tr>
                    <td>Tanggal Berobat</td>
                </tr>
                <tr>
                    <td>{{ datum.tanggalBerobat }}</td>
                </tr>
                <tr>
                    <td>Estimasi Dilayani di Loket Registrasi</td>
                </tr>
                <tr>
                    <td>{{ datum.estimasidilayani }}</td>
                </tr>
            </tbody>
        </table>
        <!--<b-button style="float: right;" class="mt-3" variant="success" block @click="convertToImage">Simpan</b-button>-->
    </b-modal>
</template>

<script>
export default {
    props: {
    show: {
        type: Boolean,
        default: false
    },
    onClose: {
        type: Function,
        default() {
        return 'Default function'
        }
    },
    datum: {
        type: Object,
        default(rawProps) {
            return {
                kdBooking: "",
                rm: "",
                nama: "",
                poliTujuan: "",
                dokterTujuan: "",
                noAntrianPoli: "",
                tanggalBerobat: "",
                noAntrianPendaftaran: "",
            }
        }
    }
    },
    methods: {
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['my-modal'].toggle('#toggle-btn')
        },
        convertToImage() {
            html2canvas(document.getElementById("tiket-table"), {
                onrendered: function (canvas) {
                    var a = document.createElement('a');
                    // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
                    a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
                    a.download = 'tiket-daftar.jpg';
                    a.click();
                }
            });
        }
    }
}
</script>

<style>
h5 {
    font-size: 28px;
}

h6 {
    font-size: 15px;
}

table.paleBlueRows {
    font-family: "Times New Roman", Times, serif;
    border: 1px solid #FFFFFF;
    width: 100%;
    height: auto;
    text-align: center;
    border-collapse: collapse;
}
table.paleBlueRows td {
    border: 1px solid lightgrey;
    padding: 3px 2px;
}
table.paleBlueRows tbody td {
    font-size: 16px;
}
table.paleBlueRows tr:nth-child(odd) {
    background: #D0E4F5;
}
table.paleBlueRows tr:nth-child(even) td {
    background: #FFFFFF;
    font-size: 18px;
    font-weight: 800;
    height: 50px;
}
</style>